import * as React from 'react';
import { CorePageWrapper } from './CorePageWrapper';
import { getMaybeActiveUserOrRefresh } from '../../../api/serverApiHelpers';
import { LoadingPageOverlay } from '../../LoadingPageOverlay';
import { UserToken, Permission } from '../../../amorg-common';
import { ProtectedPageProvider } from '../../../pages/_contexts/ProtectedPageContext';

type ProtectedPageWrapperProps = React.PropsWithChildren<{ 
    requiredPermissions:Permission[],
    hideMenu?:boolean,
    selectedMenuItemKey?:string
}>
type State = { 
    activeTokenUser:UserToken | null, 
    hasAccess:boolean,
    loading:boolean
};
export const ProtectedPageWrapper = ({ requiredPermissions, hideMenu, selectedMenuItemKey, children}: ProtectedPageWrapperProps) => {

    const [state, setState] = React.useState<State>(
        {
            activeTokenUser:null,
            hasAccess:true,
            loading:true
        }
    );

    React.useEffect(()=>{
        const getData = async() => {
            const maybeValidUser = await getMaybeActiveUserOrRefresh(requiredPermissions);
            setState({
                activeTokenUser: maybeValidUser.tokenUser,
                hasAccess:maybeValidUser.hasAccess,
                loading:false
            });
        };
        getData();
    }, []);
    
    return (
        <>
        {state.activeTokenUser &&
            <ProtectedPageProvider user={state.activeTokenUser}>
                {state.loading &&
                    <LoadingPageOverlay loading={true} />
                }
                
                {!state.loading && !state.hasAccess &&
                    <CorePageWrapper
                        activeUser={state.activeTokenUser} 
                        loading={state.loading}
                        hideMenu={hideMenu}
                        selectedMenuItemKey={selectedMenuItemKey} >
                        <p>Hov! Du har ikke rettigheder til at tilgå denne side.</p>
                    </CorePageWrapper>
                }

                {!state.loading && state.hasAccess &&
                    <CorePageWrapper
                        activeUser={state.activeTokenUser} 
                        loading={state.loading}
                        hideMenu={hideMenu}
                        selectedMenuItemKey={selectedMenuItemKey}>
                        {children}
                    </CorePageWrapper>
                }
            </ProtectedPageProvider>
        }
        </>
    )    
};